import React from 'react';
import type { DotColor } from '@/data/dotsData';

interface StatusBadgeProps {
  color: DotColor;
  label?: string;
  size?: 'sm' | 'md';
}

const CONFIG: Record<DotColor, { dot: string; bg: string; text: string; defaultLabel: string }> = {
  blue:   { dot: 'bg-dot-blue pulse-blue',   bg: 'bg-dot-blue-faint',   text: 'text-dot-blue',   defaultLabel: 'Activo' },
  yellow: { dot: 'bg-dot-yellow pulse-yellow', bg: 'bg-dot-yellow-faint', text: 'text-dot-yellow', defaultLabel: 'Desconectado' },
  red:    { dot: 'bg-dot-red pulse-red',     bg: 'bg-dot-red-faint',    text: 'text-dot-red',    defaultLabel: 'Fuera de línea' },
};

export default function StatusBadge({ color, label, size = 'md' }: StatusBadgeProps) {
  const cfg = CONFIG[color] ?? CONFIG['blue'];
  const displayLabel = label ?? cfg.defaultLabel;
  const dotSize = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2';
  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';
  const padding = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${cfg.bg} ${cfg.text} ${textSize} ${padding}`}>
      <span className={`rounded-full shrink-0 ${dotSize} ${cfg.dot}`} />
      {displayLabel}
    </span>
  );
}